import qs from 'querystring'
 
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import { Indicator, Toast } from 'mint-ui'

let url = COOKIECONSTANT.REQUEST_HOST

const getCityList = () => {
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.public.region.city-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

const getLocate = ({ longitude, latitude }) => {
  return new Promise((resolve, reject) => {
    Api.get(url ,{
      headers: {
        'X-Host':'mall.film-ticket.city.locate',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
        'longitude': longitude && `${longitude}` || '',
        'latitude': latitude && `${latitude}` || '',
      }
    }).then((data) => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    })
    .catch(e => {
      reject(e)
    })
  })
}

const setGPSAddress = (data) => {
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(data), {
      headers: {
        'X-Host': 'mall.user.address.gps.add',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

export default {
  getCityList,
  getLocate,
  setGPSAddress,
}
